// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1jiPm","right":"Footer_right__1PV2T","buttons":"Footer_buttons__2jkh6"};